import { useFormikContext } from "formik";
import React from "react";
import styles from "./ErrorMessage.module.css";

const ErrorMessage = ({ name, parent }) => {
  const { touched, errors } = useFormikContext();
  if (parent) {
    const names = name.split(".");
    const childname = names[names.length - 1];
    return (
      <div>
        {touched[parent] &&
          touched[parent]["fields"] &&
          touched[parent]["fields"][childname] &&
          errors[parent] &&
          errors[parent][childname] && (
            <p className={styles.error}>{errors[parent][childname]}</p>
          )}
      </div>
    );
  }
  return (
    <div>
      {touched[name] && errors[name] && (
        <p className={styles.error}>{errors[name]}</p>
      )}
    </div>
  );
};

export default ErrorMessage;
